import { ICity } from "@types";
import { BaseAPI } from "@utils";

class CitiesDevApi extends BaseAPI<ICity> {}

export const citiesDevApi = new CitiesDevApi("/api/v1/citiesdev");
